import { dataGroupMapRef } from './consts';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(dataGroupMapRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': opts.labelGroupMap,
          icon: '<i class="wb webconnect-google-maps"></i>',
          collectionName: '',
          projectId: opts.projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
        },
        init() {
          console.log('This is DATA GROUP MAP');
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'data-group-map') {
            return {
              type: 'data-group-map',
            };
          }
        },
      },
    ),
    view: defaultView,
  });
}
